<template>
  <fragment>
    <AppBody :title="pageTitle" :subtitle="pageSubtitle" :actions="pageActions">
      <v-form
        @submit.prevent="$lojas_usuarios.filtroUsuarios()"
        class="search-forms"
      >
        <v-row>
          <v-col cols="4">
            <label class="input-labels">Nome</label>
            <v-text-field
              solo
              placeholder="Insira o nome"
              v-model="$lojas_usuarios.filter.nome"
              type="text"
              data-cy="nome"
              class="textinput"
            >
            </v-text-field>
          </v-col>
          <v-col cols="4">
            <label class="input-labels">E-mail</label>
            <v-text-field
              solo
              placeholder="Insira o e-mail"
              v-model="$lojas_usuarios.filter.email"
              type="text"
              data-cy="email"
              class="textinput"
            >
            </v-text-field>
          </v-col>
          <v-col cols="4">
            <label class="input-labels">Status</label>
            <v-select
              height="48"
              :items="status"
              dense
              solo
              data-cy="status"
              class="textinput"
              v-model="$lojas_usuarios.filter.status"
              placeholder="Selecione o Status"
              clearable
              clear-icon="mdi-close-circle-outline"
              @click:clear="$lojas_usuarios.filter.status = ''"
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <label class="input-labels">Data inicial do cadastro</label>
            <v-text-field
              v-model="$lojas_usuarios.filter.dataInicio"
              type="tel"
              data-cy="data-inicial"
              class="textinput"
              v-mask="['XX/XX/XXXX']"
              placeholder="dd/mm/aaaa"
              hide-details
              @input="$lojas_usuarios.filter.error.dataInicio = []"
              :error-messages="$lojas_usuarios.filter.error.dataInicio"
              solo
              append-icon="mdi-calendar-blank-outline"
            >
            </v-text-field>
          </v-col>
          <v-col cols="4">
            <label class="input-labels">Data final do cadastro</label>
            <v-text-field
              v-model="$lojas_usuarios.filter.dataFim"
              type="tel"
              data-cy="data-final"
              class="textinput"
              v-mask="['XX/XX/XXXX']"
              placeholder="dd/mm/aaaa"
              @input="$lojas_usuarios.filter.error.dataFim = []"
              :error-messages="$lojas_usuarios.filter.error.dataFim"
              hide-details
              solo
              append-icon="mdi-calendar-blank-outline"
            >
            </v-text-field>
          </v-col>
          <v-col cols="4">
            <label class="input-labels">Perfil</label>
            <v-select
              height="48"
              :items="perfil"
              dense
              solo
              data-cy="perfil"
              class="textinput"
              v-model="$lojas_usuarios.filter.perfil"
              placeholder="Selecione o perfil"
              clearable
              clear-icon="mdi-close-circle-outline"
              @click:clear="$lojas_usuarios.filter.perfil = ''"
            >
            </v-select>
          </v-col>
          <v-col cols="2" class="d-flex align-self-end ml-auto">
            <v-btn
              height="48"
              data-cy="filtrar"
              class="button btn-size btn-border"
              type="submit"
              :loading="$lojas_usuarios.usuarios_loading_button"
            >
              Filtrar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-data-table
        class="table-body"
        no-data-text="Não há registro de usuários para a loja selecionada."
        loading-text="Buscando informações..."
        item-key="idusuario"
        :headers="headers"
        :loading="$lojas_usuarios.cadastro.loading"
        :items="tableValues"
        :items-per-page="10"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50],
          itemsPerPageText: 'Usuários por página:',
        }"
      >
        <template v-slot:item.actions="{ item }" class="table-actions">
          <div style="display: flex; justify-content: center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="30"
                  width="30"
                  small
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click="goToUser('editar', item)"
                  class="mr-2"
                >
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-show="item.status == 'ATIVO'"
                  :color="$config.dados.corinputs"
                  height="30"
                  v-bind="attrs"
                  v-on="on"
                  width="30"
                  small
                  icon
                  @click="
                    $lojas_usuarios.desabilitarUsuarioLoja(item.idusuario)
                  "
                >
                  <v-icon>mdi-account-cancel-outline</v-icon>
                </v-btn>
              </template>
              <span>Desativar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-show="
                    item.status != 'ATIVO' || item.status == 'ACEITE_TERMOS'
                  "
                  :disabled="item.status == 'ACEITE_TERMOS'"
                  :color="$config.dados.corinputs"
                  height="30"
                  v-bind="attrs"
                  v-on="on"
                  width="30"
                  small
                  icon
                  @click="$lojas_usuarios.habilitarUsuario(item.idusuario)"
                >
                  <v-icon>mdi-account-check-outline</v-icon>
                </v-btn>
              </template>
              <span>Ativar</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </AppBody>
  </fragment>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
export default {
  name: "Users",
  metaInfo: {
    title: "Usuários | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Usuários | ElevenTickets",
      },
    ],
  },
  props: {},
  components: {
    AppBody: () => import("@/layouts/components/AppBody.vue"),
  },
  data() {
    return {
      actions: [
        {
          name: "Novo Cadastro",
          action: () => this.goToUser("new", ""),
        },
      ],
      actionLojista: [
        {
          name: "Novo Cadastro",
          action: () => this.goToUser("new", ""),
        },
      ],
      loja: "",
      status: ["ATIVO", "INATIVO"],
      perfil: ["APP", "LOJISTA", "ADMIN"],
      activePicker: null,
      activePicker2: null,
      date: null,
      menu: false,
      menu2: false,
      NomeLoja: "Usuários",
      dtInicial: "",
      dtFinal: "",
      placeholderData: "dd/mm/aa",
      perfis: [
        "Operações",
        "Atendimento B2B",
        "Atendimento B2C",
        "Configurador",
        "Financeiro",
        "Analista",
        "Gerente",
        "Diretor",
        "Jurídico",
        "Admin",
        "Comercial",
      ],
      headers: [
        {
          text: "Nome",
          align: "center",
          sortable: true,
          value: "nome",
        },
        {
          text: "E-mail",
          align: "center",
          sortable: true,
          value: "email",
        },
        {
          text: "Perfil",
          align: "center",
          sortable: true,
          value: "perfil",
        },
        {
          text: "Data de cadastro",
          align: "center",
          sortable: true,
          value: "ins_dthr",
        },
        {
          text: "Status",
          align: "center",
          sortable: true,
          value: "status",
        },
        {
          text: "Ações",
          align: "center",
          value: "actions",
          sortable: false,
        },
      ],
    };
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    menu2(val) {
      val && setTimeout(() => (this.activePicker2 = "YEAR"));
    },
    "$store.getters.storeSequencial": function () {
      this.$lojas_usuarios.getUsuariosLoja(this.storeSequencial);
    },
  },
  computed: {
    ...mapGetters(["storeSequencial"]),
    pageTitle() {
      if (this.$axios.getLocal("oe_user_info").data.user_type === "admin")
        return "Produtores / Usuários";
      return "Loja / Usuário";
    },
    pageSubtitle() {
      if (this.$lojas_usuarios.loja_usuarios)
        return "Usuários - " + this.$lojas_usuarios.loja_usuarios;
      return "Usuários";
    },
    pageActions() {
      if (this.$axios.getLocal("oe_user_info").data.user_type === "admin")
        return this.actions;
      return this.actionLojista;
    },
    tableValues() {
      const self = this;
      if (
        this.$lojas_usuarios.usuarios &&
        this.$lojas_usuarios.usuarios.length > 0
      ) {
        this.$lojas_usuarios.usuarios.forEach(function (item) {
          item.ins_dthr = self.$config.convertDataBR(
            item.ins_dthr.substring(0, 10)
          );
        });
      }
      return _.orderBy(
        this.$lojas_usuarios.usuarios,
        usuario => {
          if (usuario.ins_dthr) {
            return new Date(
              usuario.ins_dthr.split("/").reverse().join("-")
            ).getTime();
          } else {
            return Number.MIN_VALUE;
          }
        },
        "desc"
      );
    },
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date);
      this.dtInicial = this.$config.convertDataBR(date);
    },
    save2(date) {
      this.$refs.menu2.save(date);
      this.dtFinal = this.$config.convertDataBR(date);
    },
    goToUser(type, data) {
      this.$lojas_usuarios.usuarioAddEdit = type;
      if (type === "editar") {
        this.$router.push({
          name: "producersUserSettings",
          params: {
            type: "editar",
          },
        });
        // this.$axios.rota("/lojas/usuarios/editar");
        this.$lojas_usuarios.cadastro.nome = data.nome;
        this.$lojas_usuarios.cadastro.email = data.email;
        this.$lojas_usuarios.cadastro.senha = data.senha;
        this.$lojas_usuarios.cadastro.urlHome = data.urlHome;
        this.$lojas_usuarios.cadastro.status = data.status;
        this.$lojas_usuarios.cadastro.iduserloja = data.idusuario;
        this.$lojas_usuarios.cadastro.perfil = data.perfil;

        return;
      }
      this.$router.push({
        name: "producersUserSettings",
        params: {
          type: "cadastrar",
        },
      });
    },
    openModalSelect() {
      this.$lojas_usuarios.cadastro.loading = true;
      this.$lojas_usuarios.usuarios = [];
      this.$lojas_usuarios.lojas_loading = true;
      this.$lojas_usuarios.loja_selecionada = "";
      this.$lojas_usuarios.modalSelectStore = true;
    },
  },
  updated() {
    this.$axios.setLocal("loja_usuarios", this.$lojas_usuarios.loja_usuarios);
  },
  created() {
    const lojaNome = this.$axios.getLocal("loja_usuarios").data;
    if (lojaNome) {
      this.$lojas_usuarios.loja_usuarios = lojaNome;
    }
  },
  beforeMount() {
    if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "loja")
      return this.$lojas_usuarios.getUsuariosLoja(this.storeSequencial);
    else {
      if (this.storeSequencial) {
        let store = this.storeSequencial;
        this.$lojas_usuarios.getUsuariosLoja(store);
        return;
      } else {
        this.$lojas_usuarios.modalSelectStore = true;
      }
    }
  },
  destroyed() {
    this.$lojas_usuarios.limpaFiltros();
    (this.$lojas_usuarios.loja_selecionada = ""),
      (this.$lojas_usuarios.usuarios = []),
      (this.$lojas_usuarios.cadastro.error.nome = ""),
      (this.$lojas_usuarios.cadastro.error.email = ""),
      (this.$lojas_usuarios.cadastro.error.senha = ""),
      (this.$lojas_usuarios.cadastro.error.status = "");
    this.$lojas_usuarios.cadastro.error.perfil = "";
    this.$lojas_usuarios.loja_usuarios = "";
  },
};
</script>

<style scoped>
.lojas-usuarios-container20 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 20px;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #fff;
}

.lojas-usuarios-button1 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.lojas-usuarios-icon {
  fill: var(--dl-color-gray-white);
  width: 20px;
  height: 20px;
}
</style>
